/**
 * Функция которая принимает число и выдает для него верное склонение.
 *
 * @param {number} number - Число
 * @param {[string, string, string]} [one, two, five] - Варианты склонения слова для цифры 1, для цифр от 2 до 4 и для цифр больше 4.
 * @return {string} - Склонение слова в зависимости от цифры
 *
 * @example
 *
 *     getDeclination(4, ["Поджанр", "Поджанра", "Поджанров"])
 *     // Поджанра
 */
export const getDeclination = (
  number: number,
  [one, two, five]: string[]
): string => {
  let n = Math.abs(number);
  n %= 100;
  if (n >= 5 && n <= 20) {
    return five;
  }
  n %= 10;
  if (n === 1) {
    return one;
  }
  if (n >= 2 && n <= 4) {
    return two;
  }
  return five;
};

export default getDeclination;
